import {
  GET_STOCK,
  GET_STOCK_SUCCESS,
  GET_STOCK_FAILURE,
  GET_REQUIRED_ATTRIBUTES,
  GET_REQUIRED_ATTRIBUTES_SUCCESS,
  GET_REQUIRED_ATTRIBUTES_FAILURE,
  SET_CURRENT_ITEM,
  UPDATE_ITEM_SUCCESS,
  CLOSE_DRAWER,
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAILURE,
  REPLACE_BUFFER_QUANTITY,
  REPLACE_BUFFER_QUANTITY_FAILURE,
  REPLACE_BUFFER_QUANTITY_SUCCESS
} from './stockActions';

const initialState = {
  companyStock: [],
  requiredAttributes: [],
  loading: true,
  loadingCurrentItem: true,
  openDrawer: false,
  watchUpdateStock: false,
  currentItem: {}
};

const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STOCK:
      return {
        ...state,
        loading: true
      };
    case GET_STOCK_SUCCESS:
      return {
        ...state,
        companyStock: action.payload.products.map(product => ({
          ...product,
          quantity: product.quantity > 0 ? product.quantity : 0
        })),
        loading: false
      };
    case GET_STOCK_FAILURE:
      return {
        ...state,
        loading: false
      };
    case GET_PRODUCT:
      return {
        ...state,
        loadingCurrentItem: true
      };
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        currentItem: action.payload.product,
        loadingCurrentItem: false
      };
    case GET_PRODUCT_FAILURE:
      return {
        ...state,
        loadingCurrentItem: false,
        openDrawer: false
      };
    case GET_REQUIRED_ATTRIBUTES:
      return {
        ...state,
        loading: false
      };
    case GET_REQUIRED_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        requiredAttributes: action.payload.requiredAttributes
      };
    case GET_REQUIRED_ATTRIBUTES_FAILURE:
      return {
        ...state
      };
    case CLOSE_DRAWER:
      return {
        ...state,
        openDrawer: false
      };
    case UPDATE_ITEM_SUCCESS:
      return {
        ...state,
        watchUpdateStock: !state.watchUpdateStock,
        openDrawer: false
      };
    case SET_CURRENT_ITEM:
      return {
        ...state,
        currentItem: action.payload,
        openDrawer: true,
        loadingCurrentItem: false
      };
    case REPLACE_BUFFER_QUANTITY:
      return {
        ...state,
        loading: true
      };
    case REPLACE_BUFFER_QUANTITY_FAILURE:
      return {
        ...state,
        loading: false
      };
    case REPLACE_BUFFER_QUANTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        watchUpdateStock: !state.watchUpdateStock,
        openDrawer: false
      };
    default:
      return state;
  }
};

export default stockReducer;
